import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FuseSharedModule } from '@fuse/shared.module';

import { ToolbarComponent } from 'app/layout/components/toolbar/toolbar.component';
import { MatBadgeModule } from '@angular/material/badge';
import { SecuredImageBcmModule } from '@shared/components/secured-image-bcm/secured-image-bcm.module';
import { SecuredImageU2bModule } from '@shared/components/secured-image-u2b/secured-image-u2b.module';
import { FuseSearchBarModule } from '@fuse/components';
import { MatDividerModule } from '@angular/material/divider';
import { HtmlLinksModule } from '@modules/bcm/@shared/components/html-links/html-links.module';
import { SharedModule } from '@shared/shared.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DateFnsModule } from 'ngx-date-fns';
import { ButtonBrowserBackModule } from '@core/components/button-browser-back/button-browser-back.module';
import { TranslationModule } from '@core/translation/translation.module';
import { NotificationsPanelModule } from '../notifications-panel/notifications-panel.module';
import { NavigationCustomizationDialogModule } from './navigation-customization-dialog/navigation-customization-dialog.module';
import { MyProfileDialogModule } from './my-profile-dialog/my-profile-dialog.module';
import { LanguageFlagPipe } from './language-flag.pipe';

@NgModule({
    declarations: [
        ToolbarComponent,
        LanguageFlagPipe,
    ],
    imports: [
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatToolbarModule,

        FuseSharedModule,
        MatBadgeModule,
        SecuredImageBcmModule,
        SecuredImageU2bModule,
        FuseSearchBarModule,
        MatDividerModule,
        HtmlLinksModule,
        SharedModule,
        MatProgressSpinnerModule,
        DateFnsModule,
        ButtonBrowserBackModule,
        TranslationModule,
        NotificationsPanelModule,
        NavigationCustomizationDialogModule,
        MyProfileDialogModule,
    ],
    exports: [
        ToolbarComponent
    ]
})
export class ToolbarModule {
}
